module.exports = __webpack_public_path__ + "img/music-school-icon6.f8dd0025.png";